import { Record } from 'immutable'

export interface INationalPlace {
  readonly cityState: string
  readonly combinedFIPS: string
  readonly id: string
  readonly state: string
  readonly stateFIPS: string
  readonly placeFIPS: string
  readonly placeName: string
  readonly type: string
  readonly functionalStatus: string
  readonly county: string
}

const NationalPlaceRecord = Record({
  cityState: '',
  combinedFIPS: '',
  county: '',
  functionalStatus: '',
  id: '',
  placeFIPS: '',
  placeName: '',
  state: '',
  stateFIPS: '',
  type: '',
})

export class NationalPlace extends NationalPlaceRecord
  implements INationalPlace {
  public static fromJS(initialState?: Partial<INationalPlace>) {
    if (!initialState) {
      return new NationalPlace()
    }

    const { cityState, combinedFIPS, ...rest } = initialState

    return new NationalPlace({
      cityState: `${initialState.placeName}, ${initialState.state}`,
      combinedFIPS: `${initialState.stateFIPS}${initialState.placeFIPS}`,
      ...rest,
    })
  }

  public readonly cityState: string
  public readonly combinedFIPS: string
  public readonly id: string
  public readonly state: string
  public readonly stateFIPS: string
  public readonly placeFIPS: string
  public readonly placeName: string
  public readonly type: string
  public readonly functionalStatus: string
  public readonly county: string

  constructor(initialState?: Partial<NationalPlace>) {
    initialState ? super(initialState) : super()
  }
}
